import { Store } from 'pullstate';

export enum AccessLevel {
  Personal = 'private',
  Internal = 'beta-test only',
  Public = 'stryker-wide',
}

export type Organization = {
  id: string;
  name: string;
};

export type LLModel = {
  id: string;
  name: string;
  displayName: string;
  description: string;
  maxTokenCount?: number;
  modelType: string;
  disabled: boolean;
  psuedo?: boolean;
};

export const IDLE_TIMEOUT = 12 * 60 * 60 * 1000; // 12 hours in milliseconds
export const IDLE_TIMEOUT_CONFIRMATION = 1 * 60 * 60 * 1000; // 1 hour in milliseconds

export const QUESTION_LENGTH_MAX_IN_CHARS = 10000;

export const MAX_FILE_SIZE = 15000000; // 15MB
export const FILE_UPLOAD_MAXIMUM_WARNING = 5;
export const FILE_UPLOAD_MONTHLY_LIMIT_DEFAULT = 100;
export const FILE_UPLOAD_MONTHLY_LIMIT_INFINITE = 9999;
export const DOCUMENT_UPLOAD_LIMIT = 100;
export const MAX_FILE_CHITS_VIEWABLE = 8;
export const CONVERSATION_PAGING_SIZE = 60;

export type SiteMetadata = {
  organizations: Organization[];
  gptModels: LLModel[];
  fileUploadSizeLimit?: number;
  fileUploadFileTypes?: { label: string; type: string }[];
};

const initialState: SiteMetadata = {
  organizations: [],
  gptModels: [],
};

export const MetadataStore = new Store(initialState);

export const extendGptModels = (models) => {
  return [
    {
      id: 'automatic',
      description: 'Picks model for you to use based on your prompt',
      displayName: 'Automatic',
      name: 'automatic',
      maxTokenCount: 9999999,
      modelType: ' ',
      psuedo: true,
    },
    ...models,
  ];
};

export const resetStore = () => {
  MetadataStore.update((s) => {
    return initialState;
  });
};
